export class TiposVeterinarios {
  nombre: string;
  codigo: string;
  descripcion: string;
  imagen: string;
}
